"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    '(iPhone|iPad|CPU).*OS ([56789]|10)[._].*(Safari|like Mac OS)', // old mobile safari
    'BingPreview',
    'Chrome[ /]([123]\\d|4[^1])\\.', // ancient chrome versions, except Googlebot (v41)
    'CriOS[ /][1234]\\d\\.', // ancient chrome-on-iOS versions
    'DuckDuckGo',
    'Firefox/[1234]\\d?\\.',
    'FxiOS/\\d\\.', // ancient Firefox for iOS (v < 10)
    'GSA',
    'Instagram',
    'MAGIX BROWSER',
    'MIUI',
    'MQQBrowser',
    'MSIE',
    'Media Center PC', // windows media center browser (old IE)
    'MicroMessenger', // WeChat
    'Mozilla/5.*Android [1-4]\\..*AppleWebKit', // old stock android browser
    'OPR[ /][1-5]\\d\\.', // old Operas (pre 2019)
    'Opera Coast',
    'Opera Mini',
    'Qt/',
    'QuantBrowser',
    'SamsungBrowser.[1-7]\\.', // old Samsung Internet browser (pre 2019)
    'UCBrowser',
    'Version/(\\d|10|11)\\.[\\d.]* Safari', // old Safaris (v < 12, pre 2018)
    'Vivaldi',
    'WorxWeb',
    'Yandex',
    'bit\\.ly',
    'hellotalk',
    'musical_ly',
    'wkhtmltopdf',
];
//# sourceMappingURL=ignoredUserAgents.js.map